import { useEffect } from 'react';
import { fetchCart } from '../redux/actions/fetchCart.actions';
import { useDispatch, useSelector } from 'react-redux';

import { ICartState } from '../redux/reducers';
import { cartToggleLoading } from '../redux/actions/cart.actions';
import { getUserTokenFromCookie } from 'utils/cookies.util';

const useCart = (isFetch = true): ICartState => {
  const cart = useSelector((state: { newCart: ICartState }) => state.newCart);
  const isLoyaltyFetched = useSelector((state: { userData: any; appConfig: any }) => {
    const isLoggedIn = getUserTokenFromCookie();
    if (state.appConfig.features && state.appConfig.features.share && isLoggedIn) {
      return state.userData && state.userData.isLoyaltyFetched;
    }
    return true;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (isFetch) {
      // Enabling loading of cart so that user can see loading until loyalty-info call doesn't complete
      dispatch(cartToggleLoading(true));
      // Blocking getCart until loyalty data is not fetched
      if (isLoyaltyFetched) {
        dispatch(fetchCart());
      }
    }
  }, [isFetch, isLoyaltyFetched, dispatch]);

  return cart;
};

export default useCart;
